import Rest from '@/services/Rest';

/**
 * @typedef {PaymentService}
 */
export default class PaymentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/payment'
}
